var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Badge',{attrs:{"color":_vm.color,"size":"small"}},[_vm._v(_vm._s(_vm.label)+" "),_c('i',{staticClass:"iconoir-hammer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }